import React, { useState, useEffect } from 'react';
import logo from '../../components/logo/srma-logo.webp';

export default function privacyPolicy() {
  return (
    <div style={styles.container}>
        <div style={{display:'flex', marginBottom:'50px', alignItems: 'center'}}>
          <img src={logo} width="100px" alt="Logo" style={{marginRight:'10px'}} />
          <h1 style={styles.title}>Privacy Policy</h1>
        </div>

        <p>
          SRMA ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and disclose information through our mobile application (the "App"). By using the SRMA app, you agree to the practices described below.
        </p>

        <section style={styles.section}>
          <h2>1. What Information We Collect</h2>
          <p>We collect limited personal and device-related information to enable a better user experience and for necessary app functionality. This includes:</p>
          <ul style={styles.ul}>
            <li><strong>Device Information:</strong> We may collect information about your mobile device including hardware model, operating system, and unique device identifiers (such as IMEI or Android ID) via the <code>android.permission.READ_PHONE_STATE</code> permission.</li>
            <li><strong>Purpose:</strong> This permission is used only to uniquely identify the device for security, account handling, and personalized experience. It also helps us ensure that if a user deletes their account, all associated data is securely and completely deleted from our system.</li>
            <li><strong>User Profile Information:</strong> Name, phone number, business name, and category selection during registration.</li>
            <li><strong>Usage Information:</strong> Data about how you use the app (e.g., page views, search actions) to improve features and services.</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2>2. How We Use Your Information</h2>
          <ul style={styles.ul}>
            <li>To provide and manage your account</li>
            <li>To allow buyers and sellers to view each other's clothing trade information</li>
            <li>To enhance user experience and app performance</li>
            <li>For internal analytics and improvements</li>
            <li>To automatically delete all data when a user deletes their account</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2>3. No Payments or Financial Transactions</h2>
          <p>The SRMA app does not process payments or handle any financial transactions. It is strictly a platform for sharing clothing trade information between buyers and sellers.</p>
          <p>Any payments made between parties are done outside the SRMA app. SRMA holds no responsibility or liability for any such transactions or any disputes arising from them.</p>
        </section>

        <section style={styles.section}>
          <h2>4. Sharing of Information</h2>
          <p>We do not share your personal information with any third-party service providers or advertisers. Your data is used solely for the functioning and improvement of the app.</p>
        </section>

        <section style={styles.section}>
          <h2>5. User Control & Account Deletion</h2>
          <p>You have full control over your account. Upon account deletion:</p>
          <ul style={styles.ul}>
            <li>All your personal data and trade information are permanently removed from our servers.</li>
            <li>Device-specific identifiers collected using <code>READ_PHONE_STATE</code> are also erased.</li>
          </ul>
        </section>

        <section style={styles.section}>
          <h2>6. Security</h2>
          <p>We take all reasonable steps to protect your data from unauthorized access, use, or disclosure using encryption and secure storage practices.</p>
        </section>

        <section style={styles.section}>
          <h2>7. Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. Any changes will be posted here, and your continued use of the app will signify acceptance of those changes.</p>
        </section>

        <section style={styles.section}>
          <h2>8. Contact Us</h2>
          <p>If you have questions or concerns about this privacy policy or our data practices, please contact us at:</p>
          <p><strong>Email:</strong> enquiry@srmachennai.com<br/>
            <strong>Phone:</strong> +91 94441 79541</p>
        </section>
        <p style={styles.footer}>© 2025 SRMA</p>
    </div>
  );
};

const styles = {
  section:{
    padding: '20px 0px',
  },
  container: {
    padding: '30px 60px',
    backgroundColor: '#fff',
    color: '#000',
  },
  ul: {
    paddingLeft: '20px',
  },
  title: {
    fontSize: '3rem',
    marginBottom: '10px',
  },
  subtitle: {
    fontSize: '1.25rem',
    marginBottom: '30px',
  },
  timer: {
    fontSize: '1.5rem',
    marginBottom: '50px',
  },
  footer: {
    fontSize: '0.9rem',
    color: '#94a3b8',
  },
};